
import BasicLayoutSkeleton from "../BasicLayout/index.skeleton";
import { ConfigProvider } from "antd";

export default function AppRootLayoutSkeleton() {

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: '#d9d9d9',
            footerBg: '#d9d9d9',
          }
        }
      }}
      prefixCls="ecomm"
    >
      <BasicLayoutSkeleton />
    </ConfigProvider>
  );
}
